import ChatOnHoldEvent from './ChatOnHoldEvent';
import ClientChatInactiveEvent from './ClientChatInactiveEvent';
import ClientChatTypingEvent from './ClientChatTypingEvent';
import NewChatEvent from './NewChatEvent';
import NewChatMessageEvent from './NewChatMessageEvent';
import EndChatEvent from './EndChatEvent';
import ChatTransferEvent from './ChatTransferEvent';

export default {
  ChatOnHoldEvent,
  ClientChatInactiveEvent,
  ClientChatTypingEvent,
  NewChatEvent,
  NewChatMessageEvent,
  EndChatEvent,
  ChatTransferEvent,
};
